"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPhoneDynamicCodeRequest = void 0;
var GetPhoneDynamicCodeRequest = /** @class */ (function () {
    function GetPhoneDynamicCodeRequest() {
    }
    return GetPhoneDynamicCodeRequest;
}());
exports.GetPhoneDynamicCodeRequest = GetPhoneDynamicCodeRequest;
//# sourceMappingURL=getPhoneDynamicCode.request.js.map